import ExampleSurvey from './example-survey';
import JSONSurvey from './json-langs';
const pilotVersion = Object.assign(Object.assign({}, JSONSurvey), { urlName: 'json-dsl-survey--pilot' });
const twitter = Object.assign(Object.assign({}, JSONSurvey), { urlName: 'nBL' });
const reddit = Object.assign(Object.assign({}, JSONSurvey), { urlName: 'hxH' });
const hackernews = Object.assign(Object.assign({}, JSONSurvey), { urlName: 'cmE' });
const DVS = Object.assign(Object.assign({}, JSONSurvey), { urlName: 'tKl' });
export default {
    [ExampleSurvey.urlName]: ExampleSurvey,
    // [JSONSurvey.urlName]: JSONSurvey,
    [pilotVersion.urlName]: pilotVersion,
    [twitter.urlName]: twitter,
    [reddit.urlName]: reddit,
    [hackernews.urlName]: hackernews,
    [DVS.urlName]: DVS
};
